import {
  RequirementDefinitionTemplateTier,
  TemplateTierConfig
} from "../routes/RouteCreateRequirementByTemplate/types";

export const mapRequirementDefinitionTemplateTierConfig: Record<
  RequirementDefinitionTemplateTier,
  TemplateTierConfig
> = {
  Standard: {
    id: "standard",
    name: "Standard",
    description: "Included",
    isWayfinder: false,
    backgroundColor: "gray50"
  },
  Smart: {
    id: "smart",
    name: "Smart",
    description: "Billable per verification",
    isWayfinder: true,
    backgroundColor: "blue50"
  },
  SmartAdvanced: {
    id: "smart-advanced",
    name: "Smart (advanced)",
    description: "Billable per verification",
    isWayfinder: true,
    backgroundColor: "violet50"
  }
};
